import { Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

type PurchaseOrderDocumentViewButtonProps = {
  clientUrl: string;
};

export function PurchaseOrderDocumentViewButton({
  clientUrl,
}: PurchaseOrderDocumentViewButtonProps) {
  const { t } = useTranslation('purchaseOrder');

  return (
    <Button asChild className='shrink-0' size='icon-sm' variant='ghost'>
      <a
        aria-label={t('documentsTable.viewFile')}
        href={clientUrl}
        rel='noopener noreferrer'
        target='_blank'
      >
        <Eye aria-hidden className='size-4' />
      </a>
    </Button>
  );
}
